import React from 'react'
import {Trans, useTranslation} from 'gatsby-plugin-react-i18next';

const SlackIntegration = () => {
    const { t } = useTranslation();
    return (
    <>
        <section className='hero-bg hero-bg-int position-relative slack-hero-bg section-pdn'>
            <div className='container custom_container d-flex justify-content-center align-items-center p0 m-d-block'>
                <div className='col-12 col-sm-6 col-md-6 col-lg-6'>
                    <h1 className="font-weight-semibold hero-heading mt-5 no-br">
                        <Trans>Slack Integration</Trans>
                    </h1>
                    <p className="hero-para font-weight-semibold no-br">
                        <Trans>Slack is a new layer of technology that bridges the gap between people, applications, and data. We have combined Vantage Fit and Slack together to enhance your employee wellness experience.</Trans>
                    </p>
                    <div className="pl-0 col-12 col-md-7 mtb25 d-md-flex justify-content-between align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Talk with us</Trans>
                        </a>
                    </div>
                </div>
                <div className='col-12 col-sm-6 col-md-6 col-lg-6 hero-img partnr-heroimg col2img'>
                    <div className='d-flex justify-content-center align-items-center'>
                        <img
                            className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1708943407/VantageFit/2023/Streamlining_Chat_and_Collaboration-integration.webp"
                            alt="VantageFit Partnership"
                            width="500"
                            height="447"
                            loading="eager"
                        />
                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative pl-0 pr-0">
            <div className="">
                <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                    <h2 className="font-weight-semibold section-heading text-center no-br mb-2">
                    <Trans>Slack Integration</Trans>
                    </h2>
                    <p className="sub-para font-weight-normal text-center mb-5 mt-0 text-white">
                    <Trans>Enjoy the benefits of Slack in just a few simple steps.</Trans>
                    </p>

                    <div className="container">
                        <div className='row mb-5'>
                            <div className='col-2 slack-int-img-no'>1</div>
                            <div className='col-10'>
                                <p className='sub-para font-weight-normal mb-5 text-white mt-2'><Trans>As an HR Admin, log in to your Vantage Fit account through our web platform and click on the Add to Slack option.</Trans></p>
                                <div className='slack-int-img'>
                                    <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1709013204/VantageFit/2023/slack3.png" width="908" height="468"/>
                                </div>
                            </div>
                        </div>
                        <div className='row mb-5'>
                            <div className='col-2 slack-int-img-no'>2</div>
                            <div className='col-10'>
                                <p className='sub-para font-weight-normal mb-5 text-white mt-2'><Trans>You will be then redirected to a page asking for the required permissions. Please click on the Allow button to proceed and go to the Slack workspace.</Trans></p>
                                <div className='slack-int-img'>
                                    <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1709013202/VantageFit/2023/slack-4.png" width="908" height="468"/>
                                </div>
                            </div>
                        </div>
                        <div className='row mb-5'>
                            <div className='col-2 slack-int-img-no'>3</div>
                            <div className='col-10'>
                                <p className='sub-para font-weight-normal mb-5 text-white mt-2'><Trans>To add a shortcut to the app, click on the Add apps option from the menu on the left, search the Vantage Fit app and click it.</Trans></p>
                                <div className='slack-int-img'>
                                    <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1709013203/VantageFit/2023/slack2.png" width="908" height="468"/>
                                </div>
                            </div>
                        </div>
                        <div className='row mb-5'>
                            <div className='col-2 slack-int-img-no'>4</div>
                            <div className='col-10'>
                                <p className='sub-para font-weight-normal mb-5 text-white mt-2'><Trans>Congratulations! You are now all set!</Trans></p>
                                <div className='slack-int-img'>
                                    <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1709013204/VantageFit/2023/slackn.png" width="" height=""/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>

        <div className="feat_box sect-white-col-2 shadow active_challenge">
            <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                <div className="col-12 col-md-5">
                    <div className="col-12">
                        <h2 className='font-weight-semibold py-2 section-heading'><Trans>With Slack Integration, the following benefits are now unlocked</Trans></h2>
                        <p className='section-para font-weight-normal greenTick'>
                            <ul>
                                <li><Trans>Track total number of steps.</Trans></li>
                                <li><Trans>Track total calories burnt.</Trans></li>
                                <li><Trans>Track overall Vantage Fit points earned.</Trans></li>
                                <li><Trans>Track the leaderboard progress.</Trans></li>
                            </ul>
                        </p>
                    </div>
                </div>
                <div className='col-12 col-md-7 cta-img'>
                    <div className='d-flex justify-content-center'>
                        <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1708941580/VantageFit/2023/Slack-int-benefits.webp`)} loading='lazy' alt="Wellness Challenges" width="751" height="600"/>
                    </div>
                </div>
            </div>
        </div>

        <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h2 className="font-weight-semibold section-heading text-center no-br">
                        <Trans>Embark on a Comprehensive Health <br/>Transformation!</Trans>
                    </h2>
                    <p className="sub-para font-weight-normal text-center mb-5 text-white">
                        <Trans>Join thousands unlocking their holistic health potential with Vantage Fit.</Trans>
                    </p>
                    <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Book a Demo</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>

    </>
  )
}

export default SlackIntegration
